// extracted by mini-css-extract-plugin
export default {"left_container":"SystemSttings_left_container__2I-37"};